module.exports = __webpack_public_path__ + "img/18.9bcc9f88.webp";